export const fieldNameCode = 'code';
export const fieldNameIsTrustedDevice = 'isTrustedDevice';
